import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_earthy_neutrals: FaireThemeEntity = {
  token: "discovery_theme_earthy-neutrals",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Earthy Neutrals",
  description: "Warm tones and natural materials",
  bgColor: "#E8DDD4",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
